/* Enhanced Brand Filter with Dynamic Letter Disabling */
var triggers = document.querySelectorAll('.category-list__filter a');
var filters = document.querySelectorAll('.category-list__inner .category-list__category .category-list__category-title');
var allLink = document.querySelector('.category-list__filter .all-link');
var resultElement = document.querySelector('.category-list__result');

// Function to get all available letters from current categories
function getAvailableLetters() {
  var availableLetters = new Set();
  
  filters.forEach(function(filter) {
    var categoryItem = filter.closest('.category-list__category');
    // Only count visible items (in case some are hidden by other filters)
    if (categoryItem && categoryItem.style.display !== 'none') {
      var firstLetter = filter.textContent.trim().charAt(0).toUpperCase();
      if (firstLetter) {
        availableLetters.add(firstLetter);
      }
    }
  });
  
  return availableLetters;
}

// Function to update letter availability
function updateLetterAvailability() {
  var availableLetters = getAvailableLetters();
  
  triggers.forEach(function(trigger) {
    // Skip the "All" link
    if (trigger.classList.contains('all-link')) return;
    
    var letter = trigger.textContent.trim().toUpperCase();
    
    if (availableLetters.has(letter)) {
      // Enable the letter
      trigger.classList.remove('disabled');
      trigger.style.pointerEvents = '';
    } else {
      // Disable the letter
      trigger.classList.add('disabled');
      trigger.style.pointerEvents = 'none';
      
      // Remove active state if this letter is currently active
      if (trigger.classList.contains('active')) {
        trigger.classList.remove('active');
        // Show all items if the active filter becomes unavailable
        showAllItems();
      }
    }
  });
}

// Function to show all items (extracted for reuse)
function showAllItems() {
  filters.forEach(function(filter) {
    var categoryItem = filter.closest('.category-list__category');
    if (categoryItem) {
      categoryItem.style.display = 'block';
      categoryItem.style.opacity = '1';
      categoryItem.style.transition = '';
    }
  });
  
  // Hide result element
  if (resultElement) {
    resultElement.style.display = 'none';
  }
  
  // Activate "All" link
  if (allLink) {
    allLink.classList.add('active');
  }
  
  // Remove active from other triggers
  triggers.forEach(function(trigger) {
    if (!trigger.classList.contains('all-link')) {
      trigger.classList.remove('active');
    }
  });
}

// Function to count items for a specific letter
function countItemsForLetter(letter) {
  var count = 0;
  filters.forEach(function(filter) {
    var categoryItem = filter.closest('.category-list__category');
    if (categoryItem && categoryItem.style.display !== 'none') {
      var regex = new RegExp('^' + letter, 'i');
      if (regex.test(filter.textContent.trim())) {
        count++;
      }
    }
  });
  return count;
}

// Add click event to all trigger links
triggers.forEach(function(trigger) {
  trigger.addEventListener('click', function(e) {
    e.preventDefault();

    // Skip if this is the "all-link" (handled separately)
    if (this.classList.contains('all-link')) return;
    
    // Skip if this letter is disabled
    if (this.classList.contains('disabled')) return;

    // Remove active class from all-link
    if (allLink) {
      allLink.classList.remove('active');
    }

    var takeLetter = this.textContent.trim();
    var result = 0;

    // Hide all brand items (using consistent parent targeting)
    filters.forEach(function(filter) {
      var categoryItem = filter.closest('.category-list__category');
      if (categoryItem) {
        categoryItem.style.display = 'none';
      }
    });

    // Remove active class from all triggers
    triggers.forEach(function(t) {
      t.classList.remove('active');
    });

    // Add active class to clicked trigger
    this.classList.add('active');

    // Show result element
    if (resultElement) {
      resultElement.style.display = 'block';
    }

    // Filter and show matching brands
    filters.forEach(function(filter) {
      var regex = new RegExp('^' + takeLetter, 'i');
      if (regex.test(filter.textContent.trim())) {
        result += 1;
        // Fade in effect
        var categoryItem = filter.closest('.category-list__category');
        if (categoryItem) {
          categoryItem.style.display = 'block';
          categoryItem.style.opacity = '0';
          setTimeout(function() {
            categoryItem.style.transition = 'opacity 222ms ease';
            categoryItem.style.opacity = '1';
          }, 10);
        }
      }
    });

    // Update result text
    if (resultElement) {
      resultElement.innerHTML = '<p>' + (result < 1 ? 'Category not available.' : result + ' Categories available') + '</p>';
    }
  });
});

// Handle "All" link click
if (allLink) {
  allLink.addEventListener('click', function(e) {
    e.preventDefault();
    showAllItems();
  });
}

// Initialize: Update letter availability on page load
document.addEventListener('DOMContentLoaded', function() {
  updateLetterAvailability();
});

// Function to refresh the filter (call this when collections are added/removed)
function refreshBrandFilter() {
  // Re-query the filters in case new ones were added
  filters = document.querySelectorAll('.category-list__inner .category-list__category .category-list__category-title');
  
  // Update letter availability
  updateLetterAvailability();
  
  console.log('Brand filter refreshed. Available categories:', filters.length);
}

// Optional: Auto-refresh when DOM changes (for dynamic content)
if (window.MutationObserver) {
  var observer = new MutationObserver(function(mutations) {
    var shouldRefresh = false;
    
    mutations.forEach(function(mutation) {
      // Check if category items were added or removed
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('category-list__category') || node.querySelector('.category-list__category'))) {
            shouldRefresh = true;
          }
        });
        
        mutation.removedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('category-list__category') || node.querySelector('.category-list__category'))) {
            shouldRefresh = true;
          }
        });
      }
    });
    
    if (shouldRefresh) {
      setTimeout(refreshBrandFilter, 100); // Small delay to ensure DOM is updated
    }
  });
  
  // Observe the category list container
  var categoryContainer = document.querySelector('.category-list__inner');
  if (categoryContainer) {
    observer.observe(categoryContainer, {
      childList: true,
      subtree: true
    });
  }
}

// Public function to manually refresh (useful for AJAX updates)
window.refreshBrandFilter = refreshBrandFilter;

// Debug: Check if elements are found
console.log('Triggers found:', triggers.length);
console.log('Filters found:', filters.length);
console.log('All link found:', allLink);
console.log('Result element found:', resultElement);

// Initial availability check
updateLetterAvailability();